<template>
  <div
    class="modal"
    :class="[active && 'active', modifier && `modal--${modifier}`]"
    :id="uniqueId"
    @mousedown.self="closeModal"
  >
    <div class="content block" v-if="active">
      <slot :close="closeModal" :options="modalOptions" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Modal',
  props: {
    id: String,
    modifier: String,
  },
  computed: {
    uniqueId() {
      return `modal-${this.id}`
    },
    active() {
      return this.modal === this.id
    },
    ...mapState(['modal', 'modalOptions']),
  },
  methods: {
    ...mapMutations(['closeModal']),
  },
  watch: {
    active(active) {
      if (!active) {
        this.$emit('close')
      }
      else {
        this.$emit('open', this.modalOptions)
      }
    },
  },
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  z-index: 500;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  overflow: auto;
  background: rgba(205, 209, 216, 0.6);
  @include flexCenter;

  &:not(.active) {
    display: none;
  }

  .pre-line {
    white-space: pre-line;
  }

  .content {
    padding: 20px;
    width: 335px;
    max-width: 90%;
    max-width: calc(100% - 40px);
    position: relative;

    @include PC {
      width: 320px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    margin: 0;
  }

  .actions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    justify-items: center;
    grid-gap: 6px;
    margin-top: 20px;

    button {
      width: 100%;
    }

    > button:first-child:last-child {
      grid-column: 1 / 3;
      width: 50%;
    }
  }

  &--poll {
    .content {
      width: 375px;
      padding: 30px 46px 60px;
    }
    @media (max-width: 480px) {
      .content {
        padding-left: 30px;
        padding-right: 30px;
      }
    }
  }
  &--testimonial {
    .content {
      width: 572px;
      padding: 40px;
    }
    @media (max-width: 480px) {
      .content {
        padding: 40px 30px;
      }
    }
  }

  &--auth {
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 572px;
      min-height: 400px;
      padding: 80px;

      @include mobile {
        padding: 25px 25px 25px 30px;
      }
    }

    text-align: center;

    h1 {
      font-weight: bold;
      font-size: 24px;
      line-height: 116%;
      margin-bottom: 20px;
    }

    .about {
      font-size: 14px;
      line-height: 157.5%;
      margin-bottom: 20px;
    }

    input,
    button {
      display: block;
      width: 254px;
      max-width: 100%;
      margin: 0 auto;
    }

    button {
      margin-top: 40px;
    }
  }
}
</style>
